import FilterBase from "./base";
import noUiSlider from 'nouislider';

export default class FilterPriceModule extends FilterBase {

    rangeSlider = null;
    inputMin = null;
    inputMax = null;
    valueMin = null;
    valueMax = null;
    changed = false;

    constructor(config, notification) {
        super(config, notification, "priceSelect", "priceComponentDisabled");
        this.rangeSlider = document.getElementById("priceRange");
        this.inputMin = this.component.querySelector('.price-range__inputs .input:first-child input');
        this.inputMax = this.component.querySelector('.price-range__inputs .input:last-child input');

        this.prepareRangeSlider();
        this.bindInputs();
        this.bindCloseButton(this.onCloseFilter);
        this.bindClearFiltersButton(this.onClearFilter);
    }

    onClearFilter = () => {
        this.valueMin = Math.round(parseFloat(this.settings.priceStartMin));
        this.valueMax = Math.round(parseFloat(this.settings.priceStartMax));
        this.inputMin.value = this.valueMin;
        this.inputMax.value = this.valueMax;
        this.input.value = "";
        this.rangeSlider.noUiSlider.updateOptions(
            {
                start: [this.settings.priceMin, this.settings.priceMax],
            },
            true // Boolean 'fireSetEvent'
        );
        this.changed = false;
    }

    prepareRangeSlider = () => {
        noUiSlider.create(this.rangeSlider, {
            start: [this.settings.priceStartMin, this.settings.priceStartMax],
            step: 1, // this.settings.priceStep w razie konieczności przywrócenia
            connect: true,
            range: {
                'min': this.settings.priceMin,
                'max': this.settings.priceMax
            }
        });

        this.valueMin = Math.round(parseFloat(this.settings.priceStartMin));
        this.valueMax = Math.round(parseFloat(this.settings.priceStartMax));
        this.inputMin.value = this.valueMin;
        this.inputMax.value = this.valueMax;

        this.rangeSlider.noUiSlider.on('update', (values, handle) => {
            this.valueMin = Math.round(parseFloat(values[0]));
            this.valueMax = Math.round(parseFloat(values[1]));
            const minValue = this.valueMin + " " + baseConfig.locale.PLNNight;
            const maxValue = this.valueMax + " " + baseConfig.locale.PLNNight;

            this.inputMin.value = this.valueMin;
            this.inputMax.value = this.valueMax;
            this.input.value = `${minValue} - ${maxValue}`;
            this.changed = true;
        });
    }

    bindInputs = () => {
        this.inputMin.addEventListener('change', () => {
            this.rangeSlider.noUiSlider.set([this.inputMin.value, null]);
        });

        this.inputMax.addEventListener('change', () => {
            this.rangeSlider.noUiSlider.set([null, this.inputMax.value]);
        });
        this.changed = false;
    }

    getData = () => {
        return {
            min: this.valueMin,
            max: this.valueMax,
            changed: this.changed,
        }
    }
}